"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Viewer;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Viewer() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: "45px",
    height: "45px",
    viewBox: "0 0 42.21 42.21",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "viewer-linear-gradient",
        x1: "2.74",
        y1: "3.15",
        x2: "39.78",
        y2: "38.87",
        gradientTransform: "translate(-0.06 -0.19) rotate(0.52)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.11",
          stopColor: "#969"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#67295c"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "viewer-linear-gradient-2",
        x1: "20.92",
        y1: "37.59",
        x2: "21.9",
        y2: "1.21",
        gradientTransform: "translate(21.19 -8.92) rotate(45.51)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopColor: "#d4c4d4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.73",
          stopColor: "#fff"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("radialGradient", {
        id: "radial-gradient",
        cx: "21.02",
        cy: "20.77",
        r: "8.4",
        gradientTransform: "translate(-0.06 -0.19) rotate(0.52)",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.11",
          stopColor: "#969"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.9",
          stopColor: "#67295c"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      style: {
        isolation: 'isolate'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Layer_2",
        "data-name": "Layer 2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          id: "Layer_1-2",
          "data-name": "Layer 1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            x: "0.71",
            y: "0.71",
            width: "40.8",
            height: "40.8",
            rx: "5.34",
            style: {
              fill: '#fff'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            x: "0.71",
            y: "0.71",
            width: "40.8",
            height: "40.8",
            rx: "5.34",
            style: {
              fill: 'none'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            x: "0.71",
            y: "0.71",
            width: "40.8",
            height: "40.8",
            rx: "5.34",
            style: {
              fill: 'url(#viewer-linear-gradient)'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M6,42.21a6.06,6.06,0,0,1-6-6.05V6.05A6,6,0,0,1,6.06,0H36.17a6.11,6.11,0,0,1,4.27,1.77,6,6,0,0,1,1.77,4.28V36.17a6,6,0,0,1-6.05,6H6ZM36.17,1.41H6.06A4.62,4.62,0,0,0,2.77,2.77,4.57,4.57,0,0,0,1.42,6.05V36.16A4.65,4.65,0,0,0,6,40.8H36.16a4.63,4.63,0,0,0,4.64-4.63V6.06a4.61,4.61,0,0,0-1.35-3.29,4.69,4.69,0,0,0-3.24-1.36Z",
            style: {
              fill: '#cb98c5',
              isolation: 'isolate'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("image", {
            width: "164",
            height: "164",
            transform: "translate(2.16 2.24) scale(0.24)",
            xlinkHref: "data:image/png;base64,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",
            style: {
              opacity: '.38',
              mixBlendMode: 'multiply'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            x: "8.4",
            y: "8.4",
            width: "25.42",
            height: "25.42",
            rx: "1.45",
            transform: "translate(-8.74 21.1) rotate(-44.99)",
            style: {
              fill: 'url(#viewer-linear-gradient-2)'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M29.22,17.86l-.54-1.33L28.57,18a3.43,3.43,0,1,1-3.38-3.71h.23l1.42.12-1.22-.74a8.59,8.59,0,0,0-4.43-1.27,8.74,8.74,0,1,0,8.66,8.82A8.84,8.84,0,0,0,29.22,17.86Z",
            style: {
              fill: '#67295c'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M29.17,20.84a8.42,8.42,0,0,0-.6-3.19,3.77,3.77,0,1,1-3.72-4.08h.26a8.39,8.39,0,1,0,4.06,7.26Z",
            style: {
              fill: 'url(#radial-gradient)'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M21.08,39.19a2.17,2.17,0,0,1-1.5-.63L3.66,22.62a2.16,2.16,0,0,1,0-3L19.59,3.65A2.22,2.22,0,0,1,21.11,3a2.16,2.16,0,0,1,1.52.63L38.56,19.59a2.15,2.15,0,0,1,0,3L22.62,38.56a2.14,2.14,0,0,1-1.52.63Zm-.5-1.63a.71.71,0,0,0,.52.22.75.75,0,0,0,.53-.22L37.56,21.63a.73.73,0,0,0,0-1L21.63,4.65a.75.75,0,0,0-.51-.22h0a.73.73,0,0,0-.52.22L4.65,20.58a.74.74,0,0,0,0,1.05Z",
            style: {
              fill: '#fff',
              isolation: 'isolate'
            }
          })]
        })
      })
    })]
  });
}